export enum UserTrailActionTypes {
  INFO = 0,
  READ = 1,
  CREATE = 2,
  UPDATE = 3,
  DELETE = 4,
}
